import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "../seoMeta.json";

const SITE = "https://lipityping.com";

// Keeps title/description/og/canonical/robots in sync with the current route (raw HTML is prerendered at build).
export default function PageMeta() {
    const { pathname } = useLocation();

    useEffect(() => {
        const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : "/";
        const meta = SEO[path] || { title: "Page not found | LipiTyping", description: SEO["/"].description, noindex: true };
        const url = SITE + path;

        const setTag = (selector, create, attr, value) => {
            let el = document.head.querySelector(selector);
            if (!el) {
                el = create();
                document.head.appendChild(el);
            }
            el.setAttribute(attr, value);
        };
        const setMeta = (key, value, isProp = false) => {
            const a = isProp ? "property" : "name";
            setTag(`meta[${a}="${key}"]`, () => {
                const m = document.createElement("meta");
                m.setAttribute(a, key);
                return m;
            }, "content", value);
        };

        document.title = meta.title;
        setMeta("description", meta.description);
        setMeta("og:title", meta.title, true);
        setMeta("og:description", meta.description, true);
        setMeta("og:url", url, true);
        setMeta("twitter:title", meta.title);
        setMeta("twitter:description", meta.description);
        setMeta("robots", meta.noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1");
        setTag('link[rel="canonical"]', () => {
            const l = document.createElement("link");
            l.setAttribute("rel", "canonical");
            return l;
        }, "href", url);
    }, [pathname]);

    return null;
}
